(function ($) {
  Drupal.behaviors.carousel_block_pc_formatter = {
    attach: function (context, settings) {
      var $carousel = $('.pc-carousel-formatter');

      // Carousel formatter
      $('.slick-carousel', $carousel).slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
  			autoplaySpeed: 10000
      });
    } // attach
  };
})(jQuery);
